import { graphql } from 'react-relay';

export const SubscribeToPlanMutation = graphql`
  mutation SubscribeToPlanMutation($input: SubscribeToPlanInput!) {
    SubscribeToPlan(input: $input) {
      subscription {
        id
        plan
        status
        valueCents
        dayGenerateCharge
      }
      paymentLinkUrl
      brCode
      chargeCorrelationID
      error
    }
  }
`;
